import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    redirectTo: 'socios',
    canActivate: [AuthGuard],
    data: { role: 'ROLE_HOME_VISUALIZAR' }
  },
  {
    path: 'autor',
    loadChildren: () => import('./author/author.module').then(m => m.AuthorModule)
  },
  {
    path: 'contas',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
  },
  {
    path: 'parceiros',
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule)
  },
  {
    path: 'balances',
    loadChildren: () => import('./balance/balance.module').then(m => m.BalanceModule)
  },
  {
    path: 'cargos',
    loadChildren: () => import('./office/office.module').then(m => m.OfficeModule)
  },
  {
    path: 'categorias',
    loadChildren: () => import('./categorie/categorie.module').then(m => m.CategorieModule)
  },
  {
    path: 'socios',
    loadChildren: () => import('./associate/associate.module').then(m => m.AssociateModule),
    canActivate: [AuthGuard],
    data: { role: 'ROLE_HOME_VISUALIZAR' }
  },
  {
    path: 'exports',
    loadChildren: () => import('./exports/exports.module').then(m => m.ExportsModule)
  },
  {
    path: 'charts',
    loadChildren: () => import('./charts/charts.module').then(m => m.ChartModule)
  },
  {
    path: 'contratos',
    loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule)
  },
  {
    path: 'extended-ui',
    loadChildren: () => import('./ui/extended-ui/extended-ui.module').then(m => m.ExtendedUiModule)
  },
  {
    path: 'definicoes',
    loadChildren: () => import('./definitions/definitions.module').then(m => m.DefinitionsModule)
  },
  {
    path: 'cupons',
    loadChildren: () => import('./coupons/coupons.module').then(m => m.CouponsModule)
  },
  {
    path: 'servicos-produtos',
    loadChildren: () => import('./product-service/product-service.module').then(m => m.ProductServiceModule)
  },
  {
    path: 'jogos',
    loadChildren: () => import('./game/game-routing.module').then(m => m.GameRoutingModule)
  },
  {
    path: 'ondas',
    loadChildren: () => import('./waves/waves.module').then(m => m.WavesModule)
  },
  {
    path: 'torcida-organizada',
    loadChildren: () => import('./organized-supporter/organized-supporter.module').then(m => m.OrganizedSupporterModule)
  },
  {
    path: 'rede-social',
    loadChildren: () => import('./social-network/social-network.module').then(m => m.SocialNetworkModule)
  },
  {
    path: 'conteudo-exclusivo',
    loadChildren: () => import('./exclusive-content/exclusive-content.module').then(m => m.ExclusiveContentModule)
  },
  {
    path: 'funcionalidades',
    loadChildren: () => import('./functionality/functionality.module').then(m => m.FunctionalityModule)
  },
  {
    path: 'modulos',
    loadChildren: () => import('./module/module.module').then(m => m.ModuleModule)
  },
  {
    path: 'modulos-clubes',
    loadChildren: () => import('./club-module/club-module.module').then(m => m.ClubModuleModule)
  },
  {
    path: 'lancamentos',
    loadChildren: () => import('./lancamentos/lancamentos.module').then(m => m.LancamentosModule)
  },
  {
    path: 'parametros-consulta-externa',
    loadChildren: () => import('./params-external-consult/params-external-consult.module').then(m => m.ParamsExternalConsultModule)
  },
  {
    path: 'clubes',
    loadChildren: () => import('./club/club.module').then(m => m.ClubModule)
  },
  {
    path: 'lancamento-de-contas',
    loadChildren: () => import('./lauching-accounts/lauching-accounts.module').then(m => m.LauchingAccountsModule)
  },
  {
    path: 'gamificacao',
    loadChildren: () => import('./gamification/gamification.module').then(m => m.GamificationModule)
  },
  {
    path: 'marketing',
    loadChildren: () => import('./marketing/marketing.module').then(m => m.MarketingModule)
  },
  {
    path: 'tipos-acao',
    loadChildren: () => import('./action-type/action-type.module').then(m => m.ActionTypeModule)
  },
  {
    path: 'tipo-status-pagamento',
    loadChildren: () => import('./payment-status-type/payment-status-type.module').then(m => m.PaymentStatusTypeModule)
  },
  {
    path: 'tipo-de-pagamento',
    loadChildren: () => import('./payment-method-type/payment-method-type.module').then(m => m.PaymentMethodTypeModule)
  },
  {
    path: 'mgm',
    loadChildren: () => import('./mgm/mgm.module').then(m => m.MgmModule)
  },
  {
    path: 'tipos-taxa',
    loadChildren: () => import('./tax-type/tax-type.module').then(m => m.TaxTypeModule)
  },
  {
    path: 'tipos-taxa-contrato',
    loadChildren: () => import('./contract-fee-type/contract-fee-type.module').then(m => m.ContractFeeTypeModule)
  },
  {
    path: 'fechamento-mensal',
    loadChildren: () => import('./monthly-closing/monthly-closing.module').then(m => m.MonthlyClosingModule)
  },
  {
    path: 'relatorio-de-pagamentos',
    loadChildren: () => import('./payments-report/payments-report.module').then(m => m.PaymentsReportModule),
    canActivate: [AuthGuard],
    data: { role: 'ROLE_RELATORIO_DE_PAGAMENTOS_VISUALIZAR' }
  },
  {
    path: 'relatorio-de-recebimentos',
    loadChildren: () => import('./receipt-report/receipt-report.module').then(m => m.ReceiptReportModule),
    canActivate: [AuthGuard],
    data: { role: 'ROLE_RELATORIO_DE_RECEBIMENTOS_VISUALIZAR' }
  },
  {
    path: 'relatorio-de-faturas',
    loadChildren: () => import('./invoice-report/invoice-report.module').then(m => m.InvoicesReportModule),
    canActivate: [AuthGuard],
    data: { role: 'ROLE_RELATORIO_DE_PAGAMENTOS_VISUALIZAR' }
  },
  {
    path: 'valores-taxa',
    loadChildren: () => import('./tax-value/tax-value.module').then(m => m.TaxValueModule)
  },
  {
    path: 'relatorio-movimentacao-de-status',
    loadChildren: () => import('./status-movement/status-movement-report.module').then(m => m.StatusMovementReportModule)
  },
  {
    path: 'configurar-backoffice',
    loadChildren: () => import('./config-backoffice/config-backoffice.module').then(m => m.ConfigBackofficeModule)
  },
  {
    path: 'configurar-portal',
    loadChildren: () => import('./config-portal/config-portal.module').then(m => m.ConfigPortalModule)
  },
  {
    path: 'perfis',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'locais-venda',
    loadChildren: () => import('./sales-locations/sales-locations.module').then(m => m.SalesLocationsModule)
  },
  {
    path: 'tipos-fatura',
    loadChildren: () => import('./invoice-type/invoice-type.module').then(m => m.InvoiceTypeModule)
  },
  {
    path: 'log-sistema',
    loadChildren: () => import('./system-log/system-log.module').then(m => m.SystemLogModule)
  },
  {
    path: 'planos',
    loadChildren: () => import('./plans/plans.module').then(m => m.PlansModule)
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'departamentos',
    loadChildren: () => import('./departament/departament.module').then(m => m.DepartamentModule)
  },
  {
    path: 'checkin',
    loadChildren: () => import('./checkin/checkin.module').then(m => m.CheckinModule)
  },
  {
    path: 'aprovacao-de-documentos',
    loadChildren: () => import('./approval-documents/approval-documents.module').then(m => m.ApprovalDocumentsModule)
  },
  {
    path: 'origem-socio',
    loadChildren: () => import('./partner-origin/partner-origin.module').then(m => m.PartnersOriginModule)
  },
  {
    path: 'classificacao-socio',
    loadChildren: () => import('./member-classification/member-classification.module').then(m => m.MemberClassificationModule)
  },
  {
    path: 'tags',
    loadChildren: () => import('./tag/tag.module').then(m => m.TagModule)
  },
  {
    path: 'assuntos-crm',
    loadChildren: () => import('./crm-subjects/crm-subjects.module').then(m => m.CrmSubjectsModule)
  },
  {
    path: 'integracoes',
    loadChildren: () => import('./integration/integration.module').then(m => m.IntegrationModule)
  },
  {
    path: 'status-relatorio-fechamento',
    loadChildren: () => import('./status-report/status-report.module').then(m => m.StatusReportModule)
  },
  {
    path: 'relatorios',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'tipos-plano',
    loadChildren: () => import('./plan-type/plan-type.module').then(m => m.PlanTypeModule)
  },
  {
    path: 'status-plano',
    loadChildren: () => import('./plans/plan-status/plan-status.module').then(m => m.PlanStatusModule)
  },
  {
    path: 'motivos-cancelamento',
    loadChildren: () => import('./plans/cancellation-reason/cancellation-reason.module').then(m => m.CancellationReasonModule)
  },
  {
    path: 'rotinas-batch',
    loadChildren: () => import('./batch-routines/batch-routines.module').then(m => m.BatchRoutinesModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
